<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <showButtonPdf :type="2" label="Descargar Investigación de Mercado"/>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <br>
        <el-form-item label="¿Se cuenta con datos en Compranet?"
                      prop="compranetSearch"
                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
          <div>
            <el-switch
                active-text="Sí"
                inactive-text="No"
                :disabled="onlyRead == true ? true: false"
                style="display: block"
                v-model="requestForm.compranetSearch"
                active-color="#13ce66">
            </el-switch>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="!requestForm.compranetSearch">
        <el-form-item label="Justificación de Búsqueda en Compranet"
                      prop="compranetDescription"
                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
          <el-tooltip placement="top">
            <div slot="content" style="font-size: 12pt">
              {{ descriptions.compranetDescription }}
            </div>
            <i style="font-size: 13px" class="fas fa-info"/>
          </el-tooltip>
          <el-button
              type="text"
              style="font-size: 13px"
              v-clipboard:copy="requestForm.compranetDescription"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
          >
            Copiar <i class="fas fa-copy"/>
          </el-button>
          <el-button
              type="text"
              v-if="infoUser.profile == 1"
              @click="showModalDescription(requestForm.descriptions.compranetDescription,'compranetDescription')"
              style="font-size: 13px">
            Actualizar Marca de agua <i class="fas fa-align-justify"></i>
          </el-button>
          <editor
              :init='init'
              v-show="true"
              id="compranetSearch"
              v-model="requestForm.compranetDescription"
              :disabled="onlyRead== true ? true: false"
              placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado"
          >
          </editor>
        </el-form-item>
      </el-col>
    </el-row>
    <br>
    <div class="el-table__header-wrapper el-table__body-wrapper is-scroll-left">
      <table border="1" class="el-table__header custom-lock" style="width: 100%">
        <thead class="is-group has-gutter">
        <tr>
          <th rowspan="2" style="text-align: center">
            Concepto
          </th>
          <th colspan="6" style="text-align: center">
            Cuadro comparativo general de las cotizaciones
          </th>
        </tr>
        <tr>
          <th v-for="(item2 , key2) in requestForm.providers" :key="key2+'_d'" class="custom-padding">
            <el-form-item label=" "
                          :rules="{ required: isRequired(key2) && key2 == 0, message: 'El campo es requerido',trigger: ['blur','change'] }">
              <el-input v-model="item2.name"
                        :maxlength="500"
                        :disabled="onlyRead == true ? true: false"
                        placeholder="Escriba el nombre del proveedor"
                        v-if="key2 != 3"/>
              <el-input :v-model="item2.name"
                        v-if="key2 == 3"
                        value="Búsqueda en compranet"
                        disabled
                        placeholder=""/>
            </el-form-item>
          </th>
          <th style="text-align: center !important;" class="custom-padding el-table__body">
            <center><p>Media de las cotizaciones</p></center>
            <br>
            <el-tooltip placement="top">
              <div slot="content">Valor de columna 1+ columna 2+ columna 3 entre 3.</div>
              <i style="font-size: 10px" class="fas fa-info"/>
            </el-tooltip>
          </th>
          <th style="text-align: center !important;" class="custom-padding el-table__body">
            <p>Promedio</p>
          </th>
        </tr>
        </thead>
        <tbody class="el-table__body">
        <tr v-for="(item , key) in general.providersAlias.format" :key="key+'_b'"
            v-show="item.concept != 'Nombre'">
          <td v-if="item.concept != 'Nombre'"
              :style="{background: item.concept == 'Subtotal'? '#c9c9c9c9': ''}">
            {{ item.concept }}
            <br>
            <el-tooltip placement="top" v-if="item.type == 7">
              <div slot="content"><b>Meses</b> del contrato por el <b>costo mensual</b></div>
              <i style="font-size: 10px" class="fas fa-info"/>
            </el-tooltip>
            <el-tooltip placement="top" v-if="item.type == 19">
              <div slot="content">Suma de: Gastos de instalación + otros gastos +impuestos.</div>
              <i style="font-size: 10px" class="fas fa-info"/>
            </el-tooltip>
          </td>
          <td v-for="(item2 , key2) in requestForm.providers" :key="key2+'_d'"
              :style="{background: item.type == 7? '#c9c9c9c9': ''}" class="custom-padding">
            <el-form-item label=" " v-if="item.type =='2'"
                          :prop="'providers[' + key2 + '].monthlyAgreementValidity'"
                          :rules="{ required: !compranetSearchDisable(item2,key2), message: 'El campo es requerido',trigger: ['blur','change'] }">
              <el-input-number v-model="item2.monthlyAgreementValidity"
                               style="width: 100%"
                               :disabled="compranetSearchDisable(item2,key2)"
              />
            </el-form-item>
            <el-form-item label=" " v-if="item.type == 3"
                          :prop="'providers[' + key2 + '].proposedStartDate'"
                          :rules="{ required: !compranetSearchDisable(item2,key2), message: 'El campo es requerido',trigger: ['blur','change'] }">
              <el-date-picker
                  :picker-options="pickerOptions"
                  type="date"
                  style="width: 100%"
                  :disabled=" onlyRead == true ||compranetSearchDisable(item2, key2)"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  v-model="item2.proposedStartDate">
              </el-date-picker>
            </el-form-item>
            <el-form-item label=" " v-if="item.type == 4"
                          :prop="'providers[' + key2 + '].paymentCurrency'"
                          :rules="{ required: !compranetSearchDisable(item2,key2), message: 'El campo es requerido',trigger: ['blur','change'] }">

              <el-select v-model="item2.paymentCurrency"
                         :disabled="onlyRead == true ||compranetSearchDisable(item2, key2)"
                         style="width: 100%"
                         filterable clearable
                         placeholder="Seleccionar">
                <el-option
                    v-for="(item,key2) in catalogs.catCurrencies"
                    :key="(key2 + 1)+'_currency'"
                    :label="item.name+' '+item.code"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" " v-if="item.type == 5"
                          :prop="'providers[' + key2 + '].payment_periodicity_id'"
                          :rules="{ required: !compranetSearchDisable(item2,key2), message: 'El campo es requerido',trigger: ['blur','change'] }">


              <el-select v-model="item2.payment_periodicity_id"
                         :disabled="onlyRead == true || compranetSearchDisable(item2,key2)  ? true: false"
                         style="width: 100%"
                         filterable clearable
                         placeholder="Seleccionar">
                <el-option
                    v-for="(item, key2) in catalogs.catPaymentPeriodicity"
                    :key="(key2 + 1)+ '_periodicity'"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>

            </el-form-item>
            <el-form-item label=" " v-if="item.type == 6"
                          :prop="'providers[' + key2 + '].monthlyCostWithTaxes'"
                          :rules="{ required: !compranetSearchDisable(item2,key2), message: 'El campo es requerido',trigger: ['blur','change'] }">


              <vue-numeric currency="$"
                           :disabled="compranetSearchDisable(item2, key2)"
                           class="el-input__inner"
                           separator=","
                           v-model="item2.monthlyCostWithTaxes"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 7">
              <div align="center">
                <el-form-item label=" "
                              :prop="'providers[' + key2 + '].thirdSubTotal'">
                  <vue-numeric currency="$"
                               :disabled="compranetSearchDisable(item2, key2)"
                               class="el-input__inner"
                               separator=","
                               v-model="item2.thirdSubTotal"
                               :precision="2"
                  ></vue-numeric>
                </el-form-item>
                <!-- {{subTotal(item2) | currency('$') }}-->
              </div>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 8">

              <el-input-number v-model="item2.anotherExpensesAux" :precision="2"
                               :disabled="compranetSearchDisable(item2, key2)"
                               :step="1" :min="0" style="width: 100%"/>
            </el-form-item>
            <el-form-item label=" " v-if="item.type == 9">

              <vue-numeric currency="$"
                           :disabled="compranetSearchDisable(item2, key2)"
                           class="el-input__inner"
                           separator=","
                           v-model="item2.instalmentCosts"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>

            <el-form-item label=" " v-if="item.type == 18">
              <vue-numeric currency="$"
                           :disabled="compranetSearchDisable(item2, key2)"
                           class="el-input__inner"
                           separator=","
                           v-model="item2.taxes"
                           :precision="2"
              ></vue-numeric>
            </el-form-item>

            <el-form-item
                :prop="'providers[' + key2 + '].thirdSubtotal2'"
                label=" "
                v-if="item.type == 19">
              <div align="center">
                <vue-numeric currency="$"
                             :disabled="compranetSearchDisable(item2, key2)"
                             class="el-input__inner"
                             separator=","
                             v-model="item2.thirdSubtotal2"
                             :precision="2"
                ></vue-numeric>
                <!--{{subTotal2(item2) | currency('$') }}-->
              </div>
            </el-form-item>

            <el-form-item label=" " v-if="item.type == 10">


              <vue-numeric currency="$"
                           :disabled="compranetSearchDisable(item2, key2)"
                           class="el-input__inner"
                           separator=","
                           v-model="item2.anotherExpenses"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
          </td>

          <td style="font-weight: bold;background: #c9c9c9c9; text-align: center">
            <el-form-item label=" " v-if="item.type == 2">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].meanMonths"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 6">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].meanCosts"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 7">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].meanSubtotal"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 9">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].meanInstallationCosts"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 10">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].meanOtherExpenses"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 18">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].meanTaxes"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 19">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].meanSubtotal2"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <!--{{meanQuotes(requestForm.providers, item.type)}}-->
          </td>
          <td style="font-weight: bold;background: #c9c9c9c9; text-align: center">
            <el-form-item label=" " v-if="item.type == 2">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].averageMonths"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 6">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].averageCosts"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 7">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].averageSubtotal"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 9">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].averageInstallationCosts"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 10">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].averageOtherExpenses"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 18">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].averageTaxes"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <el-form-item label=" " v-if="item.type == 19">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].averageSubtotal2"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>
            <!--{{average(requestForm.providers, item.type, requestForm.compranetSearch)}}-->
          </td>
        </tr>
        <tr>
          <td style="font-weight: bold;background: #c9c9c9c9">
            Gran Total
            <br>
            <el-tooltip placement="top">
              <div slot="content">Suma del subtotal 1 más el subtotal 2</div>
              <i style="font-size: 10px" class="fas fa-info"/>
            </el-tooltip>
          </td>
          <td style="font-weight: bold;background: #c9c9c9c9; text-align: center"
              v-for="(item2,key3) in requestForm.providers">
            <el-form-item label=" ">

              <vue-numeric currency="$"
                           :disabled="compranetSearchDisable(item2, key3)"
                           class="el-input__inner"
                           separator=","
                           v-model="item2.thirdTotal"
                           :precision="2"
              ></vue-numeric>


            </el-form-item>

            <!-- {{grandTotal(item2) | currency('$')}}-->
          </td>
          <td style="font-weight: bold;background: #c9c9c9c9; text-align: center">
            <el-form-item label=" ">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].meanTotal"
                           :precision="2"
              ></vue-numeric>

            </el-form-item>
            <!--{{grandTotalMean(requestForm.providers) | currency('$')}}-->
          </td>
          <td style="font-weight: bold;background: #c9c9c9c9; text-align: center">
            <el-form-item label=" ">

              <vue-numeric currency="$"
                           class="el-input__inner"
                           separator=","
                           v-model="requestForm.providers[3].averageTotal"
                           :precision="2"
              ></vue-numeric>

            </el-form-item>
            <!-- {{grandTotalAverage(requestForm.providers,requestForm.compranetSearch) | currency('$')}}-->
          </td>
        </tr>
        </tbody>
      </table>
      <br>
      <ComparativeChart :articles="requestForm.articles"></ComparativeChart>
      <br>
      <el-form-item label="Justificación de la selección del Proveedor seleccionado"
                    prop="justification2"
                    :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
        <el-tooltip placement="top">
          <div slot="content" style="font-size: 12pt">
            {{ descriptions.justification2 }}
          </div>
          <i style="font-size: 13px" class="fas fa-info"/>
        </el-tooltip>
        <el-button
            type="text"
            style="font-size: 13px"
            v-clipboard:copy="requestForm.justification2"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
        >
          Copiar <i class="fas fa-copy"/>
        </el-button>
        <el-button
            type="text"
            v-if="infoUser.profile == 1"
            @click="showModalDescription(requestForm.descriptions.justification2, 'justification2')"
            style="font-size: 13px">
          Actualizar Marca de agua <i class="fas fa-align-justify"></i>
        </el-button>
        <editor
            :init='init'
            id="justificationProv"
            v-model="requestForm.justification2"
            :disabled="onlyRead== true ? true: false"
            placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado"
        >
        </editor>
      </el-form-item>
      <el-form-item label="Estudio Costo Beneficio"
                    prop="costBenefitStudy"
                    :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
        <el-tooltip placement="top">
          <div slot="content" style="font-size: 12pt">
            {{ descriptions.costBenefitStudy }}
          </div>
          <i style="font-size: 13px" class="fas fa-info"/>
        </el-tooltip>
        <el-button
            type="text"
            style="font-size: 13px"
            v-clipboard:copy="requestForm.costBenefitStudy"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
        >
          Copiar <i class="fas fa-copy"/>
        </el-button>
        <el-button
            type="text"
            v-if="infoUser.profile == 1"
            @click="showModalDescription(requestForm.descriptions.costBenefitStudy, 'costBenefitStudy')"
            style="font-size: 13px">
          Actualizar Marca de agua <i class="fas fa-align-justify"></i>
        </el-button>
        <editor
            :init='init'
            id="costBenefitStudy"
            v-model="requestForm.costBenefitStudy"
            :disabled="onlyRead== true ? true: false"
            placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado"
        >
        </editor>

      </el-form-item>
      <div class="tip">
        Antecedentes de la contratación
      </div>
      <el-table
          :data="[requestForm]"
          style="width: 100%">
        <el-table-column
            prop="old_provider_name"
            label="Proveedor actual"
            min-width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.old_provider_name"
                      :disabled="onlyRead== true ? true: false"
                      placeholder=""/>
          </template>
        </el-table-column>
        <el-table-column
            prop="old_exchange_rate"
            label="Tipo de cambio"
            min-width="150">
          <template slot-scope="scope">
            <vue-numeric currency="$"
                         :disabled="onlyRead== true ? true: false"
                         class="el-input__inner"
                         separator=","
                         v-model="scope.row.old_exchange_rate"
                         :max="1000000000"
                         :precision="2"
            ></vue-numeric>
          </template>
        </el-table-column>
        <el-table-column
            prop="paymentCurrency"
            label="Tipo de moneda"
            min-width="150">
          <template slot-scope="scope">
            <el-select v-model="scope.row.old_payment_currency"
                       :disabled="onlyRead"
                       style="width: 100%"
                       filterable clearable
                       placeholder="Seleccionar">
              <el-option
                  v-for="(item,key2) in catalogs.catCurrencies"
                  :key="(key2 + 1)+'_currency'"
                  :label="item.name+' '+item.code"
                  :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            prop="old_total_local_monthly"
            label="Monto total del contrato en moneda local"
            min-width="210">
          <template slot-scope="scope">
            <vue-numeric currency="$"
                         :disabled="onlyRead== true ? true: false"
                         class="el-input__inner"
                         separator=","
                         v-model="scope.row.old_total_local_monthly"
                         :max="1000000000"
                         :precision="2"
            ></vue-numeric>
          </template>
        </el-table-column>
        <el-table-column
            prop="old_total_mxn_monthly"
            label="Monto total del contrato en MXN"
            min-width="210">
          <template slot-scope="scope">
            <vue-numeric currency="$"
                         :disabled="onlyRead== true ? true: false"
                         class="el-input__inner"
                         separator=","
                         v-model="scope.row.old_total_mxn_monthly"
                         :max="1000000000"
                         :precision="2"
            ></vue-numeric>
          </template>
        </el-table-column>
        <el-table-column
            prop="old_provider_monthly_cost"
            label="Monto mensual en moneda local"
            min-width="210">
          <template slot-scope="scope">
            <vue-numeric currency="$"
                         :disabled="onlyRead== true ? true: false"
                         class="el-input__inner"
                         separator=","
                         v-model="scope.row.old_provider_monthly_cost"
                         :max="1000000000"
                         :precision="2"
            ></vue-numeric>
          </template>
        </el-table-column>
        <el-table-column
            prop="old_duration_months"
            label="Duración en meses"
            min-width="210">
          <template slot-scope="scope">
            <el-input-number :maxlength="200" :disabled="onlyRead== true ? true: false"
                             v-model="scope.row.old_duration_months"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="old_contract_status"
            label="Estatus de la contratación"
            min-width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.old_contract_status"
                      :disabled="onlyRead== true ? true: false"
                      placeholder=""/>
          </template>
        </el-table-column>
        <el-table-column
            prop="old_authorization"
            label="Última autorización"
            min-width="120">
          <template slot-scope="scope">
            <el-date-picker
                :disabled="onlyRead== true ? true: false"
                :editable="false"
                v-model="scope.row.old_authorization"
                type="date"
                placeholder="Selecciona una fecha"
                style="width: 100%"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-dd">
            </el-date-picker>
          </template>
        </el-table-column>

      </el-table>
      <el-form-item label="Conclusión de las ventajas económicas del proyecto"
                    prop="conclusionEconomicAdvantage"
                    :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change'] }">
        <el-tooltip placement="top">
          <div slot="content" style="font-size: 12pt">
            {{ descriptions.conclusionEconomicAdvantage }}
          </div>
          <i style="font-size: 13px" class="fas fa-info"/>
        </el-tooltip>
        <el-button
            type="text"
            style="font-size: 13px"
            v-clipboard:copy="requestForm.conclusionEconomicAdvantage"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
        >
          Copiar <i class="fas fa-copy"/>
        </el-button>
        <el-button
            type="text"
            v-if="infoUser.profile == 1"
            @click="showModalDescription(requestForm.descriptions.conclusionEconomicAdvantage, 'conclusionEconomicAdvantage')"
            style="font-size: 13px">
          Actualizar Marca de agua <i class="fas fa-align-justify"></i>
        </el-button>
        <editor
            :init='init'
            id="conclusionEconomicAdvantage"
            v-model="requestForm.conclusionEconomicAdvantage"
            :disabled="onlyRead== true ? true: false"
            placeholder="Acerque el cursor al ícono de información para conocer los detalles de captura de este apartado"
        >
        </editor>
      </el-form-item>
      <Docs :onlyRead="onlyRead== true ? true: false" :sectionId="1">
        <div slot="main">
          Anexos
        </div>
      </Docs>
      <Docs :onlyRead="onlyRead== true ? true: false" :sectionId="6">
        <div slot="main">
          Suba su documento firmado "Investigación de Mercado"
        </div>
      </Docs>
      <showButtonPdf :type="2" label="Descargar Investigación de Mercado"/>
    </div>
    <br>
    <el-dialog
        :fullscreen="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="Redacción sugerida"
        :visible.sync="modalDescription">
      <el-form
               @submit.native.prevent>
        <el-row>
          <el-col>
            <el-input
                type="textarea"
                :rows="10"
                v-model="modelDescription.text"/>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveDescription()">
          Guardar
        </el-button>
        <el-button @click="modelDescription.text = ''; modalDescription = false">
          cerrar
        </el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
import Docs from '@/components/views/acquisition/partials/Docs'
import showButtonPdf from '@/components/views/acquisition/partials/showButtonPdf'
import DocsProvider from '@/components/views/acquisition/partials/DocsProvider'
import AdditionalThird from '@/components/views/acquisition/partials/AdditionalThird'
import ComparativeChart from "./ComparativeChart";
import Vue from 'vue'
import tinymce from 'vue-tinymce-editor';
import {Notification} from "element-ui";

Vue.component('tinymce', tinymce);
export default {
  props: {
    showField: {
      type: Boolean
    }
  },
  components: {
    showButtonPdf,
    Docs,
    DocsProvider,
    AdditionalThird,
    ComparativeChart
  },
  computed: {
    infoUser() {
      return this.$store.state.user
    },
    ...mapGetters("form", {
      requestForm: "requestForm",
      catalogs: "catalogs",
      general: "general",
      onlyRead: "onlyRead",
      optionEditor: "optionEditor",
      descriptions: "descriptionsAreas"
    }),
    ...mapGetters(["userInfo"]),
    difficultLifeTypeAndHealthWeek() {
      return this.userInfo && this.userInfo.office && this.userInfo.office.isHardLife == 1 ? true : false;
    }
  },
  data() {
    return {
      compranetSearch: false,
      pickerOptions: {
        disabledDate(time) {
          let yesterday = moment().subtract(1, 'day');
          return time.getTime() < yesterday;
        }
      },
      modelDescription: {},
      modalDescription: false,
      init: {
        language_url: '/tinymce/langs/es_419.js',
        language: 'es_419',
        skin_url: 'tinymce/skins/ui/oxide',
        // skin_url: 'tinymce/skins/ui/oxide-dark', // color oscuro
        height: 350,
        // inline: true,
        menubar: false,
        toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | ' +
            'bullist numlist outdent indent | link image | print preview media fullscreen',
        content_style: 'body { font-family:Montserrat; font-size:12px }'
      },
    }
  },
  watch: {
    'requestForm.providers'(value) {
      this.requestForm.providers[3].name = 'Compranet';
    }
  },

  methods: {
    ...mapActions('form', {
      fetchDescriptions: "fetchDescriptions"
    }),
    ...mapMutations('form', {
      setExplanation: "setExplanation",
      setChangePeriodicity: "setChangePeriodicity"
    }),
    subTotal(item) {
      let _a = parseFloat(item.monthlyCostWithTaxes);
      let _b = parseFloat(item.monthlyAgreementValidity);

      let subTotal = _a * _b;

      item.thirdSubTotal = subTotal;

      if (isNaN(subTotal) || subTotal == '' || !subTotal) return 0;

      try {
        return subTotal > 0 ? subTotal.toFixed(2) : 0;
      } catch (err) {
        return subTotal;
      }
    },

    subTotal2(item) {

      let _a = parseFloat(item.instalmentCosts);
      let _b = parseFloat(item.anotherExpenses);
      let _c = parseFloat(item.taxes);

      let subTotal2 = _a + _b + _c;

      item.thirdSubtotal2 = subTotal2;

      if (isNaN(subTotal2) || subTotal2 == '' || !subTotal2) return 0;

      try {
        return subTotal2 > 0 ? subTotal2.toFixed(2) : 0;
      } catch (err) {
        return subTotal2;
      }
    },

    grandTotal(item2) {
      let _a = parseFloat(item2.monthlyCostWithTaxes);
      let _b = parseFloat(item2.monthlyAgreementValidity);
      let _c = parseFloat(item2.instalmentCosts);
      let _d = parseFloat(item2.anotherExpenses);
      let _e = parseFloat(item2.taxes);


      let subTotal = (_a * _b) + _c + _d + _e;


      item2.thirdTotal = subTotal;

      if (isNaN(subTotal) || subTotal == '' || !subTotal) return 0;

      try {
        return subTotal > 0 ? subTotal.toFixed(2) : 0;
      } catch (err) {
        return subTotal;
      }

    },

    grandTotalMean(item2) {

      let mean;

      mean = this.meanValidationBis(item2[0].thirdTotal, item2[1].thirdTotal, item2[2].thirdTotal, item2[0].name, item2[1].name, item2[2].name)
      item2[3].meanTotal = mean;

      if (isNaN(mean) || mean == '' || !mean) return 0;

      try {
        return mean > 0 ? mean.toFixed(2) : 0;
      } catch (err) {
        return mean;
      }
    },

    grandTotalAverage(item2, compranet) {
      let _average = 0;

      _average = this.averageValidation(item2[0].thirdTotal,
          item2[1].thirdTotal,
          item2[2].thirdTotal,
          item2[3].thirdTotal,
          item2[0].name,
          item2[1].name,
          item2[2].name,
          compranet,
      );
      item2[3].averageTotal = _average;

      if (isNaN(_average) || _average == '' || !_average) return 0;

      try {
        return _average > 0 ? _average.toFixed(2) : 0;
      } catch (err) {
        return _average;
      }
    },

    grandTotalBis(item2) {
      let _a = parseFloat(item2.monthlyCostWithTaxes);
      let _b = parseFloat(item2.monthlyAgreementValidity);
      let _c = parseFloat(item2.instalmentCosts);
      let _d = parseFloat(item2.anotherExpenses);

      let subTotal = (_a * _b) + (_c + _d) + (_c + _d);

      if (isNaN(subTotal) || subTotal == '' || !subTotal) return 0;

      try {
        return subTotal > 0 ? subTotal.toFixed(2) : 0;
      } catch (err) {
        return subTotal;
      }

    },

    provSum(meanMap) {
      let sum = 0;
      for (var i = 0; i < meanMap.length; i++) {
        sum += parseFloat(meanMap[i], 10);
      }
      return sum
    },


    meanValidationBis(a, b, c, n1, n2, n3) {
      let prov1 = parseFloat(a);
      let prov2 = parseFloat(b);
      let prov3 = parseFloat(c);

      let name1 = n1;
      let name2 = n2;
      let name3 = n3;

      let sum = 0;

      if (name1 && name2 && name3) {
        sum = (prov1 + prov2 + prov3) / 3;
        return sum
      } else {
        if (name1 && name2) {
          sum = (prov1 + prov2) / 2;
          return sum
        }
        if (name1 && name3) {
          sum = (prov1 + prov3) / 2;
          return sum
        }
        if (name1) {
          return prov1
        }
        if (name2) {
          return prov2
        }
        if (name3) {
          return prov3
        }
      }
    },

    meanQuotes(item2, type) {

      if (!this.showField) {
        let mean = 0;
        let meanMap = 0;

        if (type == 3 || type == 4 || type == 5) {
          return 'N/A'
        }

        if (type == 2) {
          mean = this.meanValidationBis(item2[0].monthlyAgreementValidity, item2[1].monthlyAgreementValidity, item2[2].monthlyAgreementValidity, item2[0].name, item2[1].name, item2[2].name)
          item2[3].meanMonths = mean;
        }
        if (type == 6) {
          mean = this.meanValidationBis(item2[0].monthlyCostWithTaxes, item2[1].monthlyCostWithTaxes, item2[2].monthlyCostWithTaxes, item2[0].name, item2[1].name, item2[2].name)
          item2[3].meanCosts = mean
        }
        //Warning
        if (type == 7) {
          mean = this.meanValidationBis(item2[0].thirdSubTotal, item2[1].thirdSubTotal, item2[2].thirdSubTotal, item2[0].name, item2[1].name, item2[2].name)
          item2[3].meanSubtotal = mean
        }
        if (type == 9) {
          mean = this.meanValidationBis(item2[0].instalmentCosts, item2[1].instalmentCosts, item2[2].instalmentCosts, item2[0].name, item2[1].name, item2[2].name)
          item2[3].meanInstallationCosts = mean
        }
        if (type == 10) {
          mean = this.meanValidationBis(item2[0].anotherExpenses, item2[1].anotherExpenses, item2[2].anotherExpenses, item2[0].name, item2[1].name, item2[2].name)
          item2[3].meanOtherExpenses = mean
        }
        if (type == 18) {
          mean = this.meanValidationBis(item2[0].taxes, item2[1].taxes, item2[2].taxes, item2[0].name, item2[1].name, item2[2].name)
          item2[3].meanTaxes = mean
        }
        if (type == 19) {
          mean = this.meanValidationBis(item2[0].thirdSubtotal2, item2[1].thirdSubtotal2, item2[2].thirdSubtotal2, item2[0].name, item2[1].name, item2[2].name)
          item2[3].meanSubtotal2 = mean
        }

        if (isNaN(mean) || mean == '' || !mean) return 0;

        try {
          return type == 2 && mean > 0 ? mean.toFixed(0) : mean.toFixed(2)
        } catch (err) {
          return mean;
        }
      }
    },

    averageValidation(a, b, c, d, n1, n2, n3, n4) {

      let prov1 = parseFloat(a);
      let prov2 = parseFloat(b);
      let prov3 = parseFloat(c);
      let compranet = parseFloat(d);

      let name1 = n1;
      let name2 = n2;
      let name3 = n3;
      let compranetFlag = n4;

      let sum = 0;

      if (name1 && name2 && name3 && compranetFlag) {
        sum = (prov1 + prov2 + prov3 + compranet) / 4;
        return sum
      } else {
        if (compranetFlag) {
          if (name1 && name2) {
            sum = (prov1 + prov2 + compranet) / 3;
            return sum
          } else {
            if (name1 && name3) {
              sum = (prov1 + prov3 + compranet) / 3;
              return sum
            }
            if (name2 && name3) {
              sum = (prov2 + prov3 + compranet) / 3;
              return sum
            }
            if (name1) {
              sum = (prov1 + compranet) / 2;
              return sum
            }
            if (name2) {
              sum = (prov2 + compranet) / 2;
              return sum
            }
            if (name3) {
              sum = (prov3 + compranet) / 2;
              return sum
            }
          }
        } else {
          if (name1 && name2 && name3) {
            sum = (prov1 + prov2 + prov3) / 3;
            return sum
          } else {
            if (name1 && name2) {
              sum = (prov1 + prov2) / 2;
              return sum
            }
            if (name1 && name3) {
              sum = (prov1 + prov3) / 2;
              return sum
            }
            if (name2 && name3) {
              sum = (prov2 + prov3) / 2;
              return sum
            }
            if (name1) {
              return prov1
            }
            if (name2) {
              return prov2
            }
            if (name3) {
              return prov3
            }
          }
        }
      }
    },

    average(item2, type, compranet) {
      let _average = 0;

      if (type == 2) {
        _average = this.averageValidation(item2[0].monthlyAgreementValidity,
            item2[1].monthlyAgreementValidity,
            item2[2].monthlyAgreementValidity,
            item2[3].monthlyAgreementValidity,
            item2[0].name,
            item2[1].name,
            item2[2].name,
            compranet,
        );
        item2[3].averageMonths = _average
      }
      if (type == 6) {
        _average = this.averageValidation(item2[0].monthlyCostWithTaxes,
            item2[1].monthlyCostWithTaxes,
            item2[2].monthlyCostWithTaxes,
            item2[3].monthlyCostWithTaxes,
            item2[0].name,
            item2[1].name,
            item2[2].name,
            compranet,
        );
        item2[3].averageCosts = _average;
      }
      if (type == 7) {
        _average = this.averageValidation(item2[0].thirdSubTotal,
            item2[1].thirdSubTotal,
            item2[2].thirdSubTotal,
            item2[3].thirdSubTotal,
            item2[0].name,
            item2[1].name,
            item2[2].name,
            compranet,
        );
        item2[3].averageSubtotal = _average;
      }
      if (type == 9) {
        _average = this.averageValidation(item2[0].instalmentCosts,
            item2[1].instalmentCosts,
            item2[2].instalmentCosts,
            item2[3].instalmentCosts,
            item2[0].name,
            item2[1].name,
            item2[2].name,
            compranet,
        );
        item2[3].averageInstallationCosts = _average;
      }
      if (type == 10) {
        _average = this.averageValidation(item2[0].anotherExpenses,
            item2[1].anotherExpenses,
            item2[2].anotherExpenses,
            item2[3].anotherExpenses,
            item2[0].name,
            item2[1].name,
            item2[2].name,
            compranet,
        );
        item2[3].averageOtherExpenses = _average;
      }
      if (type == 18) {
        _average = this.averageValidation(item2[0].taxes,
            item2[1].taxes,
            item2[2].taxes,
            item2[3].taxes,
            item2[0].name,
            item2[1].name,
            item2[2].name,
            compranet,
        );
        item2[3].averageTaxes = _average
      }
      if (type == 19) {
        _average = this.averageValidation(item2[0].thirdSubtotal2,
            item2[1].thirdSubtotal2,
            item2[2].thirdSubtotal2,
            item2[3].thirdSubtotal2,
            item2[0].name,
            item2[1].name,
            item2[2].name,
            compranet,
        );
        item2[3].averageSubtotal2 = _average
      }
      if (type == 3 || type == 4 || type == 5)
        return 'N/A'

      if (isNaN(_average) || _average == '' || !_average) return 0;

      try {
        return type == 2 && _average > 0 ? _average.toFixed(0) : 0
      } catch (err) {
        return _average;
      }
    },

    meanEachItem(item) {
      let _sum = 0;

      let _amount = parseFloat(item.amount);
      let _a = parseFloat(item.costProv1);
      let _b = parseFloat(item.costProv2);
      let _c = parseFloat(item.costProv3);
      let _d = parseFloat(item.searchCompranet);

      _sum = (_a + _b + _c + _d);

      let _mean = 0;

      if (item.searchCompranet) {

        _mean = (_amount * _sum) / 4;

      } else {

        _mean = (_amount * _sum) / 3;
      }

      if (isNaN(_mean) || _mean == '' || !_mean) return 0;

      try {
        item.mean = _mean.toFixed(2)
        return _mean > 0 ? _mean.toFixed(2) : 0
      } catch (err) {
        item.mean = _mean
        return _mean;
      }
    },

    compranetSearchDisable(item2, key) {
      let _articles = this.requestForm.articles;
      if (key == 3) {
        if (!this.requestForm.compranetSearch) {
          this.requestForm.providers[key].monthlyAgreementValidity = 0;
          this.requestForm.providers[key].proposedStartDate = null;
          this.requestForm.providers[key].paymentCurrency = null;
          this.requestForm.providers[key].monthlyCostWithTaxes = 0;
          this.requestForm.providers[key].instalmentCosts = 0;
          this.requestForm.providers[key].anotherExpenses = 0;
          this.requestForm.providers[key].payment_periodicity_id = null;
          this.requestForm.providers[key].taxes = 0;
          _.forEach(_articles, (article, key) => {
            if (!article.isHidden) {
              article.searchCompranet = 0;
            }
          });

          return true
        } else {
          return false
        }
      } else {
        if (key == 0 && !this.requestForm.providers[0].name) {
          _.forEach(_articles, (article, key) => {
            if (!article.isHidden) {
              article.costProv1 = 0;
            }
          });
          return false
        }
        if (key == 1 || key == 2) {
          if (key == 1 && !this.requestForm.providers[1].name) {
            _.forEach(_articles, (article, key) => {
              if (!article.isHidden) {
                article.costProv2 = 0;
              }
            })
          } else if (key == 2 && !this.requestForm.providers[2].name) {
            _.forEach(_articles, (article, key) => {
              if (!article.isHidden) {
                article.costProv3 = 0;
              }
            })
          }

          if (item2.name) {
            return false
          } else {
            this.requestForm.providers[key].monthlyAgreementValidity = 0;
            this.requestForm.providers[key].proposedStartDate = null;
            this.requestForm.providers[key].paymentCurrency = null;
            this.requestForm.providers[key].monthlyCostWithTaxes = 0;
            this.requestForm.providers[key].instalmentCosts = 0;
            this.requestForm.providers[key].anotherExpenses = 0;
            this.requestForm.providers[key].taxes = 0;
            this.requestForm.providers[key].payment_periodicity_id = null;

            return true
          }
        }
      }
    },

    isRequired(key) {
      if (this.difficultLifeTypeAndHealthWeek == true || this.difficultLifeTypeAndHealthWeek == 1) {
        if (key == 0) {
          return true;
        }
        return false;
      }
      return true;
    },
    changePeriodicity(payload) {
      this.setChangePeriodicity(payload);
    },
    async onCopy(e) {
      try {
        e.text.replace('&ntilde;', 'ñ');
        e.text.replace('&Ntilde;', 'Ñ');
        await this.$copyText(e.text.replace(/(<([^>]+)>)/ig, '')).then(async function (ee) {
          Notification.success('Se copió el texto correctamente.')
        }, function (e) {
          console.log(e)
        })
      } catch (e) {
        console.log("copy clipboard ", e)
      }
    },
    onError: function (e) {
      alert('Failed to copy the text to the clipboard')
      console.log(e);
    },
    showModalDescription(text, model) {
      let _object = {
        text: text,
        model: model
      }
      this.modelDescription = Object.assign({}, _object);
      this.modalDescription = true;
    },
    saveDescription() {
      axios.post('/api/acquisitions/s-description', {
        description: this.modelDescription
      }).then(response => {
        if (response.data.success) {
          Notification.success(response.data.message);
          this.modalDescription = false;
          this.fetchDescriptions()
        } else {
          Notification.error(response.data.message)
        }
      }).catch(e => {
        console.log("error ", e);
        Notification.error('No se pudo procesar su solicitud.')
      })
    }
  },

}
</script>

<style>
.custom-padding {
  padding: 5px;
}

.custom-padding .el-form-item .el-form-item__label {
  padding: 0;
  line-height: 0;
  margin: 0;
}
</style>